<template>
    <div>
        <iframe
            id="ddcFrame"
            src="about:blank"
            width="0"
            height="0"
            frameborder="0"
        ></iframe>
    </div>
</template>
<script>
    export default {
        components: {
        },
        props: {
            ddc_url: {
                required: true,
            },
            jwt: {
                required: true,
            },
            bin: {
                required: true,
            }
        },
        data(){
            return {}
        },
        methods: {},
        mounted(){
            let content = ` <html lang="en">
                                <head>
                                </head>
                                <body>
                                    <form name="ddcForm" id="ddcForm" method="post" action="${this.ddc_url}">
                                        <input type="hidden" name="JWT" id="JWT" value="${this.jwt}"/>
                                        <input type="hidden" name="Bin" id="Bin" value="${this.bin}"/>
                                    </form>
                                    <script type="text/javascript">
                                        window.onload = function () {
                                            document.forms['ddcForm'].submit();
                                        }
                                    <\/script>
                                </body>
                            </html>`;
            
            let doc = document.getElementById('ddcFrame').contentWindow.document;
            doc.open();
            doc.write(content);
            doc.close();
        },
    }
</script>
<style scoped lang="scss">
</style>